import { apiURL, callAPI } from 'api/main';

import { middlewareConfirmedInvitations } from './middleware';

interface IGetConfirmedInvitationsParams {
  forcedToken?: string;
}

export default async ({
  forcedToken,
}: IGetConfirmedInvitationsParams): Promise<IMatchmakingInvitation[]> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/v3/sys/match/confirmed`,
      method: 'GET',
      needToken: true,
      forcedToken,
    });

    const { data } = res.request;

    if (data) {
      return middlewareConfirmedInvitations(data);
    }

    return [];
  } catch (ex) {
    return [];
  }
};
